import React, { useEffect, useState } from 'react'
import Spiner from '../../components/modals/Spiner'
import { useSearchParams } from 'react-router-dom'
import '../../scss/OrderConfirm.scss'

const isLocalhost =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname === 'easybuy.local'

const BASENAME = isLocalhost ? window.location.origin : ''

export default function OrderConfirm() {
  const [searchParams] = useSearchParams()
  const order = searchParams.get('orden')
  const [spiner, setSpiner] = useState(false)

  useEffect(() => {
    setSpiner(true)

    const token = localStorage.getItem('authToken')
    const isLoggedIn = !!token

    if (!isLoggedIn) {
      window.location.href = BASENAME + global.HOME
      return
    }

    setSpiner(false)
  }, [])

  return (
    <main className="main order-confirm-page">
      <Spiner opt={spiner} />

      <div className="container">
        <div className="order-confirm-wrapper">
          <div className="order-confirm-card">
            <div className="order-confirm-icon">
              <i className="icon-check"></i>
            </div>

            <span className="order-confirm-label">Compra realizada</span>

            <h1>¡Gracias por tu compra!</h1>

            <p className="order-confirm-message">
              Tu pedido ha sido realizado correctamente. Hemos recibido tu orden
              y ya puedes consultar toda la información desde tu cuenta.
            </p>

            <div className="order-number-box">
              <span>Número de pedido</span>
              <strong>#{order}</strong>
            </div>

            <p className="order-confirm-help">¿Qué deseas hacer ahora?</p>

            <div className="order-confirm-actions">
              <a
                href={BASENAME + global.ORDERDETAIL + '?orden=' + order}
                className="order-confirm-btn order-confirm-btn-primary"
              >
                <span>Ver detalle de la orden</span>
                <i className="icon-long-arrow-right"></i>
              </a>

              <a
                href={BASENAME + global.ORDERCRASTREO + '?orden=' + order}
                className="order-confirm-btn order-confirm-btn-secondary"
              >
                <span>Ver rastreo</span>
                <i className="icon-long-arrow-right"></i>
              </a>
            </div>

            <a href={BASENAME + global.HOME} className="order-confirm-home">
              <i className="icon-home"></i>
              Continuar comprando
            </a>
          </div>
        </div>
      </div>
    </main>
  )
}
